import { render, staticRenderFns } from "./TheRadarIsiBadge.vue?vue&type=template&id=f0d9da30&scoped=true&"
import script from "./TheRadarIsiBadge.vue?vue&type=script&lang=js&"
export * from "./TheRadarIsiBadge.vue?vue&type=script&lang=js&"
import style0 from "./TheRadarIsiBadge.vue?vue&type=style&index=0&id=f0d9da30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d9da30",
  null
  
)

export default component.exports